import Swiper, { Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'

const init = el => {
  const totalSlides = el.querySelectorAll('.swiper-slide').length
  if (totalSlides < 2) return

  return new Swiper(el, {
    modules: [
      Navigation
    ],
    cssMode: false,
    slidesPerView: 'auto',
    spaceBetween: 8,
    speed: 600,
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev')
    }
  })
}

export default () => {
  document.querySelectorAll('.js-product-lifestyle-carousel').forEach(el => init(el))
}
